export enum AuthLevel {
    NONE = 0,
    PASSWORD = 1,
    LOGIN = 2,
}
